import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=1d19c9c0&scoped=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=1d19c9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19c9c0",
  null
  
)

export default component.exports